import { PageLayout } from '~/components/unified/PageLayout';

export function ContactSales() {
  return (
    <PageLayout.Content className="h-full">
      <h1>Contact Sales to Access Prospector</h1>
    </PageLayout.Content>
  );
}
